// extracted by mini-css-extract-plugin
module.exports = {"banner":"consentBanner_banner__yb7Ii","content":"consentBanner_content__D6uPf","actions":"consentBanner_actions__BvYCr","policy":"consentBanner_policy___bCEv"};